import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { System } from "../models/systems";

const useResizeScreen = () => {
  const { appId } = useParams<{ appId: string }>();
  const [screenHeight, setScreenHeight] = useState<string | number>(
    window.innerHeight,
  );

  useEffect(() => {
    document.getElementById(appId || "")?.scrollIntoView();
    const onResizeScreen = () => {
      setScreenHeight(System.isPwaInstalled() ? "100vh" : window.innerHeight);
    };
    window?.addEventListener("resize", onResizeScreen);
    return () => {
      window?.removeEventListener("resize", onResizeScreen);
    };
  }, []);

  return screenHeight;
};

export default useResizeScreen;
